/* eslint-disable react/no-array-index-key */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useEmblaCarousel from "embla-carousel-react";
import React, { useCallback, useEffect, useState } from "react";
import styled, { css } from "styled-components";

interface EmblaProps {
    id: any;
    zones: string[];
}

interface CarouselStyles {
    mainContainer?: InjectableCss;
    carouselItem?: InjectableCss;
}

const carouselStyles: CarouselStyles = {
    mainContainer: {
        css: css`
            overflow: hidden;
            width: 96%;
            margin: 0 auto;
        `,
    },
    carouselItem: {
        css: css`
            width: 100%;
        `,
    },
};

const CarouselSlidesContainer = styled.div`
    display: flex;
`;

const CarouselSlide = styled.div`
    padding: 0;
    position: relative;
    flex: 0 0 auto;
`;

const CarouselSlideInner = styled.div`
    width: fit-content;
    height: 100%;
    padding: 0 15px;
    position: relative;
    display: flex;
    flex-direction: column;
`;
const styles = carouselStyles;

const EmblaCarousel = ({ id, zones }: EmblaProps) => {
    const [emblaRef, embla] = useEmblaCarousel({
        dragFree: true,
        containScroll: "trimSnaps",
    });

    const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
    const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

    // THIS CODE WILL BE NEEDED IF THE BUTTONS WILL BE NEEDED
    // const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
    // const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

    // const onSelect = useCallback(() => {
    //     if (!embla) {
    //         return;
    //     }
    //      setPrevBtnEnabled(embla.canScrollPrev());
    //      setNextBtnEnabled(embla.canScrollNext());
    // }, [embla]);

    // useEffect(() => {
    //     if (!embla) {
    //         return;
    //     }
    //     embla.on("select", onSelect);
    //     onSelect();
    // }, [embla, onSelect]);

    return (
        <StyledWrapper {...styles.mainContainer} ref={emblaRef}>
            <CarouselSlidesContainer>
                {zones.map((zone, index) => (
                    <CarouselSlide key={index}>
                        <CarouselSlideInner>
                            <Zone contentId={id} zoneName={zone}></Zone>
                        </CarouselSlideInner>
                    </CarouselSlide>
                ))}
            </CarouselSlidesContainer>
        </StyledWrapper>
    );
};

export default EmblaCarousel;
